import { Button, Modal } from "react-bootstrap";
import {
  FaCalendarCheck,
  FaChartLine,
  FaCheckDouble,
  FaClipboardCheck,
  FaFileAlt,
  FaPowerOff,
  FaPeopleArrows,
  FaUserCheck,
  FaUsers,
  FaSignOutAlt,
  FaExchangeAlt,
} from "react-icons/fa";
import { SlUserFemale } from "react-icons/sl";

import { Link, useNavigate } from "react-router-dom";
import "./style.css";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { USER_LOGOUT, SetEntornoEmp } from "../../pages/redux/store/Actions";
import { businessThemes } from "../../theme/businessThemes";
import { useParams } from "react-router";

interface Acceso {
  id: number;
  id_client: number;
  id_profile: number;
  profile: string;
  client_name: string;
  idbusiness_group: number;
}

// ── Subcomponente extraído para reducir nesting (SonarQube TIPO 6) ───────────
interface MenuLinkProps {
  to: string;
  icon: React.ReactNode;
  label: string;
  color: string;
}

const MenuLink: React.FC<MenuLinkProps> = ({ to, icon, label, color }) => (
  <li>
    <Link className="dropdown-item" to={to} style={{ color }}>
      {icon} {label}
    </Link>
  </li>
);

// ── Subcomponente para opciones del selector de panel ────────────────────────
interface PanelOptionProps {
  acceso: any;
}

const PanelOption: React.FC<PanelOptionProps> = ({ acceso }) => (
  <option
    key={acceso.id}
    value={acceso.id}
    style={{ backgroundColor: "#fff", color: "#333" }}
  >
    {acceso.profile === "Colaborador" ? "Evaluador Externo" : acceso.profile}
    {acceso.profile !== "Administrador" ? ` — ${acceso.client_name}` : ""}
  </option>
);

// ── BarraMenu helpers (SonarQube T4: reducir CC) ─────────────────────────────
const loadAccesosFromStorage = (setAccesos: any) => {
  try {
    const raw = localStorage.getItem("userAccesos");
    if (!raw) return;
    const parsed: Acceso[] = JSON.parse(raw);
    if (Array.isArray(parsed) && parsed.length > 1) setAccesos(parsed);
  } catch {}
};

const barraHandleConfirmLogout = (dispatch: any, navigate: any, setShowLogoutModal: any) => {
  localStorage.clear(); dispatch(USER_LOGOUT()); navigate("/"); setShowLogoutModal(false);
};
const barraHandleCancelLogout = (setShowLogoutModal: any) => setShowLogoutModal(false);
const barraCheckAuth = (empFirstName: string, navigate: any) => {
  const authToken = localStorage.getItem("authToken");
  const user = localStorage.getItem("user");
  if (empFirstName === "" && !authToken && !user) navigate("/");
};


const buildPanelPayload = (emp: any, acceso: Acceso) => ({
  first_name: emp.first_name, id_user: emp.id_user,
  last_name: emp.last_name, profile: acceso.profile,
  token: emp.token, user: emp.user ?? "",
  idbusiness_group: acceso.idbusiness_group,
  id_client: acceso.id_client, client_name: acceso.client_name,
});


const BarraMenu = () => {
  const params = useParams();
  const paramsLenght = Object.keys(params).length;
  const navigate = useNavigate();
  const emp: any = useSelector((state: any) => state.emp);
  const businessGroupId = emp?.idbusiness_group || 1;
  const theme = businessThemes[businessGroupId] || businessThemes[1];
  const company: any = useSelector((state: any) => state.company);

  const dispatch = useDispatch();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [accesos, setAccesos] = useState<Acceso[]>([]);

  // Cargar accesos múltiples desde localStorage
  useEffect(() => {
    loadAccesosFromStorage(setAccesos);
  }, []);

  const handleConfirmLogout = () => barraHandleConfirmLogout(dispatch, navigate, setShowLogoutModal);
  const handleCancelLogout = () => barraHandleCancelLogout(setShowLogoutModal);

  // Panel activo: el acceso que coincide con perfil y cliente del emp actual
  const panelActivo = accesos.find(
    (a) => a.profile === emp.profile && a.id_client === emp.id_client
  );

  // buildPanelPayload extraído (SonarQube T4: reducir CC)
  const cambiarPanel = (acceso: Acceso) => {
    const userPayload = buildPanelPayload(emp, acceso);
    dispatch(SetEntornoEmp(userPayload));
    localStorage.setItem("userData", JSON.stringify(userPayload));
    navigate("/home");
  };
  useEffect(() => { barraCheckAuth(emp.first_name, navigate); }, [emp.first_name, navigate]);

  return (
    <nav className="navbar navbar-expand-lg modern-nav">
      
      <div className="container-fluid nav-container"
        style={{
          background: theme.navBackground,       
        }}
      >
        {/* Imagén grupo */}
        <div className="logo-container">
          <div
            className="image-wrapper"
            title={`Perfil de ${emp.first_name} ${emp.last_name}`}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "4px 8px",
            }}
          >
            <img
              src={theme.logo}
              alt="Company Logo"
              style={{
                maxHeight: theme.logoMaxHeight || "44px",
                width: "auto",
                maxWidth: "180px",
                objectFit: "contain",
              }}
            />
          </div>
        </div>

        {/* Ícono de hamburguesa en modo responsive */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Botón Home */}
        <div className="d-flex align-items-center">
          <Button
            type="button"
            className="btn-minimal d-flex align-items-center gap-1 fw-bold"
            onClick={() => navigate("/home")}
            title="Volver al inicio"
            style={{
              backgroundColor: "rgba(0,0,0,0.15)",
              color: theme.navTextColor,
              border: "none",
              borderRadius: "8px",
              padding: "6px 14px",
              transition: "0.2s ease-in-out",
              fontSize: "0.9rem",
            }}
          >
            <i className="fas fa-home"></i>
            <span>Inicio</span>
          </Button>
        </div>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mx-auto mb-2 mb-lg-0 d-flex justify-content-center gap-4">

            {/* Gestión - solo Administrador */}
            { ["Administrador"].includes(emp.profile) && (
              <li className="nav-item dropdown me-3">
                <Link
                  to="#!"
                  id="navbarDropdownDashboard"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  key={0}
                  className="nav-link dropdown-toggle text-decoration-none me-2 d-flex flex-row align-items-center gap-1"
                  style={{ color: theme.navTextColor }}
                >
                  <FaChartLine /> Gestión
                </Link>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li>
                    <Link className="dropdown-item" to="/gestionColaboradores" style={{color: theme.dropdownItemColor}}>
                      <FaPeopleArrows /> Usuarios
                    </Link>
                  </li>
                  {emp.profile === "Administrador" && (
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/gestionCategoriasEvaluaciones"
                        style={{color: theme.dropdownItemColor}}
                      >
                        <FaClipboardCheck /> Categorías de Evaluación
                      </Link>
                    </li>
                  )}
                  {emp.profile === "Administrador" && (
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/gestionFormatoEvaluacion"
                        style={{color: theme.dropdownItemColor}}
                      >
                        <FaClipboardCheck /> Formato de evaluación
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            )}

            {/* Administración - solo Administrador */}
            {["Administrador"].includes(emp.profile) && (
              <li className="nav-item dropdown me-3">
                <Link
                  to="#!"
                  className="nav-link dropdown-toggle text-decoration-none me-2 d-flex flex-row align-items-center gap-1"
                  id="navbarDropdownInventario"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  key={0}
                  style={{ color: theme.navTextColor }}
                >
                  <FaCalendarCheck /> Administración
                </Link>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdownInventario">
                  <li>
                    <Link className="dropdown-item" to="/admonUsuariosExternos" style={{color: theme.dropdownItemColor}}>
                      <FaUsers /> Cambiar contraseñas
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/admonUsuariosParametros"
                      style={{color: theme.dropdownItemColor}}
                    >
                      <FaClipboardCheck /> Parámetros
                    </Link>
                  </li>
                </ul>
              </li>
            )}

            {/* Evaluaciones - solo Evaluador */}
            {["Evaluador"].includes(emp.profile) && (
              <li className="nav-item dropdown me-3">
                <Link
                  to="#!"
                  className="nav-link dropdown-toggle text-decoration-none me-2 d-flex flex-row align-items-center gap-1 fw-bold"
                  id="navbarDropdownReferencia"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  key={0}
                  style={{ color: theme.navTextColor }}
                >
                  <FaUserCheck />
                  Evaluaciones
                </Link>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdownReferencia">
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/realizarEvaluaciones"
                      style={{color: theme.dropdownItemColor}}
                    >
                      <FaCheckDouble /> Realizar evaluaciones
                    </Link>
                  </li>
                </ul>
              </li>
            )}

            {/* Reportes - solo Evaluador */}
            {["Evaluador"].includes(emp.profile) && (
              <li className="nav-item dropdown me-3">
                <Link
                  to="#!"
                  className="nav-link dropdown-toggle text-decoration-none me-2 d-flex flex-row align-items-center gap-1 fw-bold"
                  id="navbarDropdownConsultas"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  key={0}
                  style={{ color: theme.navTextColor }}
                >
                  <FaFileAlt /> Reportes
                </Link>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdownConsultas">
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/reporteEvaluaciones"
                      style={{ color: theme.dropdownItemColor }}
                    >
                      <FaClipboardCheck /> Evaluaciones{" "}
                    </Link>
                  </li>
                </ul>
              </li>
            )}

            {/* ── Selector de panel — solo si el usuario tiene múltiples accesos ── */}
            {accesos.length > 1 && (
              <li className="nav-item d-flex align-items-center me-3">
                <div className="d-flex align-items-center gap-2">
                  <FaExchangeAlt
                    size={14}
                    style={{ color: theme.navTextColor, opacity: 0.8 }}
                  />
                  <select
                    className="form-select form-select-sm"
                    style={{
                      fontSize: "13px",
                      fontWeight: "600",
                      cursor: "pointer",
                      minWidth: "180px",
                      backgroundColor: "rgba(255,255,255,0.15)",
                      color: theme.navTextColor,
                      border: `1px solid ${theme.navTextColor}40`,
                      borderRadius: "6px",
                      padding: "4px 8px",
                    }}
                    value={panelActivo?.id ?? ""}
                    onChange={(e) => {
                      const elegido = accesos.find(
                        (a) => String(a.id) === e.target.value
                      );
                      if (elegido) cambiarPanel(elegido);
                    }}
                  >
                    {accesos.map((a) => (
                      <option
                        key={a.id}
                        value={a.id}
                        style={{ backgroundColor: "#fff", color: "#333" }}
                      >
                        {a.profile === "Colaborador"
                          ? "Evaluador Externo"
                          : a.profile}
                        {a.profile !== "Administrador"
                          ? ` — ${a.client_name}`
                          : ""}
                      </option>
                    ))}
                  </select>
                </div>
              </li>
            )}

          </ul>

          {/* Perfil de usuario */}
          <div className="d-flex align-items-center">
            <div className="user-profile me-2 d-none d-lg-block">
              <span className="text-secondary fw-medium"></span>
            </div>
            <div className="dropdown">
              <button
                className="btn btn-light rounded-circle border d-flex justify-content-center align-items-center p-0"
                style={{ width: "40px", height: "40px" }}
                id="userDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                title={`Perfil de ${emp.first_name} ${emp.last_name}`}
              >
                <SlUserFemale />
              </button>
              <ul
                className="dropdown-menu dropdown-menu-end shadow border-0"
                aria-labelledby="userDropdown"
              >
                <li>
                  <div className="dropdown-item-text px-3 py-2">
                    <div className="fw-bold">
                      {emp.first_name} {emp.last_name}
                    </div>
                    <div className="text-muted small">{emp.profile}</div>
                    {emp.client_name && (
                      <div className="text-muted small">{emp.client_name}</div>
                    )}
                  </div>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <button
                    className="dropdown-item d-flex align-items-center gap-2 text-danger"
                    onClick={() => setShowLogoutModal(true)}
                  >
                    <FaSignOutAlt /> Cerrar sesión
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showLogoutModal}
        onHide={handleCancelLogout}
        centered
        size="sm"
      >
        <Modal.Header closeButton>
          <Modal.Title>Cerrar sesión</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center py-4">
          <FaPowerOff size={40} className="text-danger mb-3" />
          <p className="mb-0">¿Está seguro que desea salir?</p>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button variant="outline-secondary" onClick={handleCancelLogout}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleConfirmLogout}>
            Cerrar sesión
          </Button>
        </Modal.Footer>
      </Modal>
    </nav>
  );
};

export default BarraMenu;